"use strict";
var lodash_1 = require("lodash");
/*
 * This is needed because PublicationXref rdf:id values and
 * GPML GraphId values are not necessarily mutually exclusive
 * and unique within a given pathway.
 * For example, WP306, version 80308, has rdf:id="d8a" and
 * a DataNode with GraphId="d8a".
 */
function generatePublicationXrefId(originalId) {
    return 'PublicationXref' + originalId;
}
exports.generatePublicationXrefId = generatePublicationXrefId;
/* LSV means JSON-LD @list or @set values
 */
function arrayify(input) {
    if (typeof input === 'undefined') {
        return [];
    }
    return lodash_1.isArray(input) ? input : [input];
}
exports.arrayify = arrayify;
;
function isJsonldListSetPrimitive(x) {
    var TYPE = typeof x;
    return ['string', 'number', 'boolean'].indexOf(TYPE) > -1 ||
        x === null ||
        (TYPE !== 'undefined' && x.hasOwnProperty('@value'));
}
exports.isJsonldListSetPrimitive = isJsonldListSetPrimitive;
;
function getValuesLSV(input) {
    if (typeof input === 'undefined') {
        return [];
    }
    return arrayify(input)
        .map(function (x) {
        return x && x.hasOwnProperty('@value') ? x['@value'] : x;
    })
        .filter(isJsonldListSetPrimitive);
}
exports.getValuesLSV = getValuesLSV;
;
function intersectsLSV(x, y) {
    return !lodash_1.isEmpty(lodash_1.intersection(getValuesLSV(x), getValuesLSV(y)));
}
exports.intersectsLSV = intersectsLSV;
;
function unionLSV() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    return lodash_1.union(lodash_1.flatten(inputs.map(getValuesLSV)));
}
exports.unionLSV = unionLSV;
;
exports.supportedNamespaces = [
    'http://pathvisio.org/GPML/2013a',
    'http://genmapp.org/GPML/2010a',
    'http://genmapp.org/GPML/2008a',
    'http://genmapp.org/GPML/2007'
];
function extendDefaults(gpmlElement, defaults) {
    return gpmlElement;
}
exports.extendDefaults = extendDefaults;
;
function applyDefaults(gpmlElement, defaultsArray) {
    var defaultsArrayClone = lodash_1.cloneDeep(defaultsArray);
    // from http://lodash.com/docs#partialRight
    return lodash_1.reduce(defaultsArrayClone, function (accumulator, defaults) {
        return lodash_1.defaultsDeep(accumulator, defaults);
    }, gpmlElement);
}
exports.applyDefaults = applyDefaults;
;
function convertAttributesToJson(gpmlElement, dataElement, converter, attributeDependencyOrder) {
    var converterKeys = lodash_1.keys(converter);
    var attributeList, attributes;
    attributes = gpmlElement.attributes;
    var attributeKeys = lodash_1.keys(attributes);
    var handledAttributeKeys = lodash_1.intersection(converterKeys, attributeKeys);
    if (handledAttributeKeys.length < attributes.length) {
        var unhandledAttributeKeys = lodash_1.difference(converterKeys, attributeKeys);
        console.warn('No handler for attribute(s) "' + unhandledAttributeKeys.join(', ') + '" for element "' + gpmlElement.name + '"');
    }
    attributeList = lodash_1.map(handledAttributeKeys, function (attributeKey) {
        return {
            name: attributeKey,
            value: attributes[attributeKey].value,
            dependencyOrder: attributeDependencyOrder.indexOf(attributeKey),
        };
    });
    if (!!attributeList && attributeList.length > 0) {
        if (attributeList.length > 1) {
            attributeList.sort(function (a, b) {
                return a.dependencyOrder - b.dependencyOrder;
            })
                .filter(function (attribute) {
                return typeof attribute.value !== 'undefined' && !isNaN(attribute.value) && attribute.value !== null;
            });
        }
        attributeList.forEach(function (attributeListItem) {
            converter[attributeListItem.name](attributeListItem.value);
        });
    }
    return dataElement;
}
exports.convertAttributesToJson = convertAttributesToJson;
;
// TODO get rid of some of this border style code. some of it is not being used.
function getBorderStyleNew(gpmlLineStyle) {
    // Double-lined EntityNodes will be handled by using a symbol with double lines.
    // Double-lined edges will be rendered as single-lined, solid edges, because we
    // shouldn't need double-lined edges other than for cell walls/membranes, which
    // should be symbols. Any double-lined edges are curation issues.
    var lineStyleToBorderStyleMapping = {
        'Solid': 'solid',
        'Double': 'solid',
        'Broken': 'dashed'
    };
    var borderStyle = lineStyleToBorderStyleMapping[gpmlLineStyle];
    if (!!borderStyle) {
        return borderStyle;
    }
    else {
        console.warn('LineStyle "' + gpmlLineStyle + '" does not have a corresponding borderStyle. Using "solid"');
        return 'solid';
    }
}
exports.getBorderStyleNew = getBorderStyleNew;
;
function getBorderStyle(gpmlLineStyle, pathvisioDefault) {
    // Double-lined EntityNodes will be handled by using a symbol with double lines.
    // Double-lined edges will be rendered as single-lined, solid edges, because we
    // shouldn't need double-lined edges other than for cell walls/membranes, which
    // should be symbols. Any double-lined edges are curation issues.
    var lineStyleToBorderStyleMapping = {
        'Solid': 'solid',
        'Double': 'solid',
        'Broken': 'dashed'
    };
    var borderStyle;
    if (gpmlLineStyle !== pathvisioDefault) {
        if (!!gpmlLineStyle) {
            borderStyle = lineStyleToBorderStyleMapping[gpmlLineStyle];
            if (borderStyle) {
                return borderStyle;
            }
            else {
                console.warn('LineStyle "' + gpmlLineStyle + '" does not have a corresponding borderStyle. Using "solid"');
                return 'solid';
            }
        }
        else {
            return 'solid';
        }
    }
    else {
        // TODO use code to actually get the default
        return 'whatever the default value is';
    }
}
exports.getBorderStyle = getBorderStyle;
;
// see http://blog.acipo.com/matrix-inversion-in-javascript/
/**
 * Calculate the inverse matrix.
 * @returns {Matrix}
 */
function invertMatrix(M) {
    // I use Guassian Elimination to calculate the inverse:
    // (1) 'augment' the matrix (left) by the identity (on the right)
    // (2) Turn the matrix on the left into the identity by elemetry row ops
    // (3) The matrix on the right is the inverse (was the identity matrix)
    // There are 3 elemtary row ops: (I combine b and c in my code)
    // (a) Swap 2 rows
    // (b) Multiply a row by a scalar
    // (c) Add 2 rows
    //if the matrix isn't square: exit (error)
    if (M.length !== M[0].length) {
        return;
    }
    //create the identity matrix (I), and a copy (C) of the original
    var i = 0, ii = 0, j = 0, dim = M.length, e = 0, t = 0;
    var I = [], C = [];
    for (i = 0; i < dim; i += 1) {
        // Create the row
        I[I.length] = [];
        C[C.length] = [];
        for (j = 0; j < dim; j += 1) {
            //if we're on the diagonal, put a 1 (for identity)
            if (i === j) {
                I[i][j] = 1;
            }
            else {
                I[i][j] = 0;
            }
            // Also, make the copy of the original
            C[i][j] = M[i][j];
        }
    }
    // Perform elementary row operations
    for (i = 0; i < dim; i += 1) {
        // get the element e on the diagonal
        e = C[i][i];
        // if we have a 0 on the diagonal (we'll need to swap with a lower row)
        if (e === 0) {
            //look through every row below the i'th row
            for (ii = i + 1; ii < dim; ii += 1) {
                //if the ii'th row has a non-0 in the i'th col
                if (C[ii][i] !== 0) {
                    //it would make the diagonal have a non-0 so swap it
                    for (j = 0; j < dim; j++) {
                        e = C[i][j]; //temp store i'th row
                        C[i][j] = C[ii][j]; //replace i'th row by ii'th
                        C[ii][j] = e; //repace ii'th by temp
                        e = I[i][j]; //temp store i'th row
                        I[i][j] = I[ii][j]; //replace i'th row by ii'th
                        I[ii][j] = e; //repace ii'th by temp
                    }
                    //don't bother checking other rows since we've swapped
                    break;
                }
            }
            //get the new diagonal
            e = C[i][i];
            //if it's still 0, not invertable (error)
            if (e === 0) {
                return;
            }
        }
        // Scale this row down by e (so we have a 1 on the diagonal)
        for (j = 0; j < dim; j++) {
            C[i][j] = C[i][j] / e; //apply to original matrix
            I[i][j] = I[i][j] / e; //apply to identity
        }
        // Subtract this row (scaled appropriately for each row) from ALL of
        // the other rows so that there will be 0's in this column in the
        // rows above and below this one
        for (ii = 0; ii < dim; ii++) {
            // Only apply to other rows (we want a 1 on the diagonal)
            if (ii === i) {
                continue;
            }
            // We want to change this element to 0
            e = C[ii][i];
            // Subtract (the row above(or below) scaled by e) from (the
            // current row) but start at the i'th column and assume all the
            // stuff left of diagonal is 0 (which it should be if we made this
            // algorithm correctly)
            for (j = 0; j < dim; j++) {
                C[ii][j] -= e * C[i][j]; //apply to original matrix
                I[ii][j] -= e * I[i][j]; //apply to identity
            }
        }
    }
    //we've done all operations, C should be the identity
    //matrix I should be the inverse:
    return I;
}
exports.invertMatrix = invertMatrix;
;
// from http://tech.pro/tutorial/1527/matrix-multiplication-in-functional-javascript
function multiplyMatrices(m1, m2) {
    var result = [];
    for (var i = 0; i < m1.length; i++) {
        result[i] = [];
        for (var j = 0; j < m2[0].length; j++) {
            var sum = 0;
            for (var k = 0; k < m1[0].length; k++) {
                sum += m1[i][k] * m2[k][j];
            }
            result[i][j] = sum;
        }
    }
    return result;
}
exports.multiplyMatrices = multiplyMatrices;
;
/**
 * rotate
 *
 * @param theta (float): rotation angle in radians, measured clockwise
 * @return transformation matrix for rotation
 *
 * Note that for Canvas and SVG, the y axis points down:
 *
 *  *---------> x
 *  |
 *  |
 *  |
 *  v
 *
 *  y
 *
 * The transformation matrix returned takes this into account and is intentionally
 * different from the transformation matrix that would be returned if the y-axis
 * pointed up, as is common in many math classes.
 */
function rotate(theta) {
    theta = typeof theta === 'number' ? theta : 0;
    var matrix = [
        [Math.cos(theta), (-1) * Math.sin(theta), 0],
        [Math.sin(theta), Math.cos(theta), 0],
        [0, 0, 1]
    ];
    return matrix;
}
exports.rotate = rotate;
;
function scale(args) {
    var xScale = typeof args[0] === 'number' ? args[0] : 1, yScale = typeof args[1] === 'number' ? args[1] : xScale;
    return [
        [xScale, 0, 0],
        [0, yScale, 0],
        [0, 0, 1]
    ];
}
exports.scale = scale;
;
var GpmlUtilities = this;
function getTransformationMatrix(transformationSequence) {
    // Start with identity matrix
    var concatenatedTransformationMatrix = [[1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]];
    transformationSequence.forEach(function (transformation) {
        var thisTransformationMatrix = GpmlUtilities[transformation.key](transformation.value);
        concatenatedTransformationMatrix = multiplyMatrices(concatenatedTransformationMatrix, thisTransformationMatrix);
    });
    return concatenatedTransformationMatrix;
}
exports.getTransformationMatrix = getTransformationMatrix;
;
function translate(args) {
    var xTranslation = typeof args[0] === 'number' ? args[0] : 0, yTranslation = typeof args[1] === 'number' ? args[1] : 0;
    return [
        [1, 0, xTranslation],
        [0, 1, yTranslation],
        [0, 0, 1]
    ];
}
exports.translate = translate;
;
function multiplyMatrixByVector(transformationMatrix, vector) {
    var x = vector[0][0] * transformationMatrix[0][0] + vector[1][0] * transformationMatrix[0][1] + vector[2][0] * transformationMatrix[0][2], y = vector[0][0] * transformationMatrix[1][0] + vector[1][0] * transformationMatrix[1][1] + vector[2][0] * transformationMatrix[1][2], z = vector[0][0] * transformationMatrix[2][0] + vector[1][0] * transformationMatrix[2][1] + vector[2][0] * transformationMatrix[2][2];
    return [[x],
        [y],
        [z]];
}
exports.multiplyMatrixByVector = multiplyMatrixByVector;
;
function transform(args) {
    var element = args.element, x = element.x, y = element.y, width = element.width, height = element.height, transformOrigin = args.transformOrigin || '50% 50%', transformationSequence = args.transformationSequence || [];
    var transformOriginKeywordMappings = {
        'left': '0%',
        'center': '50%',
        'right': '100%',
        'top': '0%',
        'bottom': '100%'
    };
    var transformOriginKeywordMappingsKeys = Object.keys(transformOriginKeywordMappings);
    var i = 0;
    var transformOriginValues = [];
    var transformOriginPoint = transformOrigin.split(' ')
        .map(function (value) {
        if (transformOriginKeywordMappingsKeys.indexOf(value) > -1) {
            value = transformOriginKeywordMappings[value];
        }
        if (value.indexOf('%') > -1) {
            var decimalPercent = (parseFloat(value) / 100);
            if (i === 0) {
                value = decimalPercent * width;
            }
            else {
                value = decimalPercent * height;
            }
        }
        else if (value.indexOf('em') > -1) {
            // TODO refactor. this is hacky.
            value = parseFloat(value) * 12;
        }
        else {
            value = parseFloat(value);
        }
        transformOriginValues[i] = value;
        if (i === 0) {
            value += x;
        }
        else {
            value += y;
        }
        i += 1;
        return value;
    });
    // shift origin from top left corner of element bounding box to point specified by transformOrigin (default: center of bounding box)
    transformationSequence.unshift({
        key: 'translate',
        value: [transformOriginPoint[0], transformOriginPoint[1]]
    });
    // shift origin back to top left corner of element bounding box
    transformationSequence.push({
        key: 'translate',
        value: [(-1) * transformOriginPoint[0], (-1) * transformOriginPoint[1]]
    });
    var transformationMatrix = getTransformationMatrix(transformationSequence);
    var topLeftPoint = [[x],
        [y],
        [1]];
    var bottomRightPoint = [[x + width],
        [y + height],
        [1]];
    var topLeftPointTransformed = multiplyMatrixByVector(transformationMatrix, topLeftPoint);
    var bottomRightPointTransformed = multiplyMatrixByVector(transformationMatrix, bottomRightPoint);
    element.x = topLeftPointTransformed[0][0];
    element.y = topLeftPointTransformed[1][0];
    element.width = bottomRightPointTransformed[0][0] - element.x;
    element.height = bottomRightPointTransformed[1][0] - element.y;
    return element;
}
exports.transform = transform;
;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/gpml-utilities.js
// module id = 18
// module chunks = 0